import _slicedToArray from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useState, useEffect, useLayoutEffect, useMemo } from "react";
import Mousetrap from "mousetrap";
var createStateHook = function createStateHook() {
  var mousetraps = /* @__PURE__ */new Map();
  var keys = [];
  var bindKeys = function bindKeys(nextKeys) {
    nextKeys.forEach(function (k) {
      if (k.disabled) {
        return;
      }
      if (k.ref) {
        if (!k.ref.current) {
          return;
        }
        var element = k.ref.current;
        if (!mousetraps.has(element)) {
          mousetraps.set(element, new Mousetrap(element));
        }
        mousetraps.get(element).bind(k.keys, k.callback, k.action);
      } else {
        if (!mousetraps.get(void 0)) {
          mousetraps.set(void 0, Mousetrap);
        }
        mousetraps.get(void 0).bind(k.keys, k.callback, k.action);
      }
    });
  };
  var addKeys = function addKeys(nextKeys) {
    keys = [].concat(_toConsumableArray(keys), _toConsumableArray(nextKeys));
    bindKeys(nextKeys);
  };
  var removeKeys = function removeKeys(nextKeys) {
    keys = keys.filter(function (k) {
      return !nextKeys.includes(k);
    });
    nextKeys.forEach(function (k) {
      var _a, _b;
      if (k.ref) {
        if (!k.ref.current) {
          return;
        }
        (_a = mousetraps.get(k.ref.current)) == null ? void 0 : _a.unbind(k.keys, k.action);
      } else {
        (_b = mousetraps.get(void 0)) == null ? void 0 : _b.unbind(k.keys, k.action);
      }
    });
    var _iterator = _createForOfIteratorHelper(mousetraps),
      _step;
    try {
      var _loop = function _loop() {
          var _step$value = _slicedToArray(_step.value, 1),
            element = _step$value[0];
          if (element === void 0) {
            if (keys.some(function (k) {
              return k.ref === void 0;
            })) {
              return 0; // continue
            }
          } else {
            if (keys.some(function (k) {
              var _a;
              return ((_a = k.ref) == null ? void 0 : _a.current) === element;
            })) {
              return 0; // continue
            }
          }
          mousetraps.delete(element);
        },
        _ret;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    bindKeys(keys);
  };
  return function () {
    var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
    useEffect(function () {
      setState(keys);
    }, []);
    return [state, addKeys, removeKeys];
  };
};
var useHotkeyState = createStateHook();
var useHotkeys = function useHotkeys(shortcuts) {
  var _useHotkeyState = useHotkeyState(),
    _useHotkeyState2 = _slicedToArray(_useHotkeyState, 3),
    keys = _useHotkeyState2[0],
    addKeys = _useHotkeyState2[1],
    removeKeys = _useHotkeyState2[2];
  useLayoutEffect(function () {
    if (shortcuts) {
      addKeys(shortcuts);
    }
    return function () {
      if (shortcuts) {
        removeKeys(shortcuts);
      }
    };
  }, [addKeys, removeKeys, shortcuts]);
  return useMemo(function () {
    return keys.reduce(function (agg, cur) {
      if (!agg.find(function (a) {
        return a.keys === cur.keys && a.ref && cur.ref;
      })) {
        agg.push(cur);
      }
      return agg;
    }, []);
  }, [keys]);
};
var isMac = false;
try {
  if (navigator) isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
} catch (e) {
  console.warn(e);
}
var MODIFIER_KEY = isMac ? "⌘" : "CTRL";
function getHotkeyText(hotkey) {
  return hotkey.replace("modifier", MODIFIER_KEY).replace("mod", MODIFIER_KEY).replace("shift", "⇧");
}
export { MODIFIER_KEY, getHotkeyText, useHotkeyState, useHotkeys };